import { Sparkles } from 'lucide-react';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface StepBasicsProps {
    name: string;
    setName: (v: string) => void;
    description: string;
    setDescription: (v: string) => void;
}

export function StepBasics({
    name,
    setName,
    description,
    setDescription
}: StepBasicsProps) {
    return (
        <div className="space-y-6">
            <div className="">
                <h2 className="mb-0 font-medium text-2xl">The basics</h2>
                <p className="text-muted-foreground text-base">
                    Give your agent a name and short description.
                </p>
            </div>

            <div className="space-y-4">
                <div className="space-y-1.5">
                    <Label className="font-medium text-sm">Agent name</Label>
                    <Input
                        placeholder="e.g. Franchise Sales Digest"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="p-3 h-auto text-base!"
                    />
                </div>

                <div className="space-y-1.5">
                    <Label className="font-medium text-sm">Description</Label>
                    <Textarea
                        placeholder="What does this agent analyse and who is it for?"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={8}
                        className="resize"
                    />
                </div>
            </div>

            {/* Preview card */}
            {/* <div className="flex items-center gap-4 bg-muted/30 p-4 border border-border border-dashed rounded-[14px]">
                <div
                    className="flex justify-center items-center rounded-[13px] size-[46px] shrink-0"
                    style={{ backgroundColor: '#2563eb' }}
                >
                    <Sparkles className="size-5 text-white" />
                </div>
                <div>
                    <div className="font-semibold text-[15px]">
                        {name || 'Agent name'}
                    </div>
                    <div className="mt-0.5 text-[12px] text-muted-foreground">
                        Preview · this is how your agent appears
                    </div>
                </div>
            </div> */}
        </div>
    );
}
